"use client";
import { jsx as t } from "react/jsx-runtime";
import { withCmsDataHandling as l } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import m from "../../layout/Container/Container.js";
import { sharedHandler as s } from "@ingeniorforeningen/figurine-core";
import { forwardRef as n } from "react";
import { pageTopDeliveryApiParser as d } from "./PageTop.helpers.js";
import c from "./variants/PageTopArticle.js";
import f from "./variants/PageTopBanner.js";
import g from "./variants/PageTopClassic.js";
const a = n((i, p) => {
  const { variant: o = "classic", ...r } = i, e = { ...r };
  return delete e.title, delete e.subtitle, delete e.teaser, delete e.editLink, delete e.image, delete e.subject, delete e.authorByline, delete e.articleType, /* @__PURE__ */ t(m, { size: "xl", mt: 0, ...e, ref: p, children: o === "banner" ? /* @__PURE__ */ t(f, { ...r }) : o === "article" ? /* @__PURE__ */ t(c, { ...r }) : /* @__PURE__ */ t(g, { ...r }) });
});
a.displayName = "PageTop";
const P = l({
  Component: s(a),
  deliveryApiParser: d
});
P.displayName = a.displayName;
export {
  a as _PageTop,
  P as default
};
